import cn from 'classnames';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';

import styles from './corporateRowWrapper.module.scss';

const CorporateRowWrapper = ({ Row, ...props }) => {
  const { rowData: { droppedTranche }, checks } = props;

  const getAccessedRow = () => (
    <Row
      { ...props }
      className={ cn({ [styles.canceled]: droppedTranche }) }
    />
  );

  if (props.rowIndex === 0) return getAccessedRow();

  const rowCallbacks = {
    onClick: (event) => {
      event.preventDefault();
      event.stopPropagation();
    },
  };

  return (
    <CheckUserAccess
      conditions={ [{
        checks,
        fallback: <Row { ...props } className={ styles.rowBlur } rowCallbacks={ rowCallbacks } />,
      }] }
    >
      { getAccessedRow() }
    </CheckUserAccess>
  );
};

export default CorporateRowWrapper;
